import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byKey: {},
};

const scheduleSelectionCacheSlice = createSlice({
  name: 'scheduleSelectionCache',
  initialState,
  reducers: {
    cacheSelectionDetail(state, action) {
      const key = action?.payload?.key;
      if (!key) return;
      state.byKey[key] = action?.payload?.payload ?? null;
    },
    clearSelectionDetailCache(state) {
      state.byKey = {};
    },
  },
});

export const { cacheSelectionDetail, clearSelectionDetailCache } =
  scheduleSelectionCacheSlice.actions;

export default scheduleSelectionCacheSlice.reducer;

